import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61b621da"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("刷新数据")
const _hoisted_2 = {
  style: {"margin-top":"20px"},
  "element-loading-text": "正在提交数据，请稍后"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 已被催办： ")
const _hoisted_5 = { class: "fc-d fw-700" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ，最近催办： ")
const _hoisted_7 = { class: "fc-d fw-700" }
const _hoisted_8 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 催办 ")

import { ref, unref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useAppStore } from '@/store/app';
import { GetWorkTimeLineApi } from '@/apis/tasks/task.api';
import { AuditUrgeApi } from '@/apis/contract/contract.api';
import moment from 'moment';
import { BillAuditTourgeApi, BillWorkListApiByPlan } from '../../../apis/ct_bills/bill.api'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const login = useAppStore().getLoginInfo;

const state = reactive({
	show: false,
	loading: false,
	urgeLoad: false,
	planId: '',
	createUserId: '',
	workList: [] as any[],
	tabList: [] as any[],
	firstTab: '',
});

const load = {
	/* 获取审批流程记录 */
	getWorkListData: (planId: string) => {
		state.tabList=[]
        state.loading = true
        BillWorkListApiByPlan(planId)
            .then((res) => {
                if (!res.succeeded) {
                    ElMessage.error(`流程数据读取失败，可能的原因是:${res.errors}`);
                } else {
                    state.workList = res.data;
					for (let i in state.workList) 
					{
						if (!(state.tabList.includes(state.workList[i].bill_no)))
						{
							state.tabList.push(state.workList[i].bill_no)
							
							console.log(state.tabList)
						}
					}
					state.firstTab=state.tabList[0]
					state.activeTab=state.firstTab
					console.log(state)
                }
            })
            .finally(() => {
                state.loading = false
            })
}
};

const actions = {
	/* 催办 */
	onUrgeBtnClick: (workId: string) => {
		state.urgeLoad = true;
		AuditUrgeApi(workId)
			.then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`操作失败，可能的原因是：${res.errors}`);
				} else {
					ElMessage.success(`催办操作成功`);
					if (state.planId) load.getWorkListData(state.planId);
				}
			})
			.finally(() => (state.urgeLoad = false));
	},
	/* 刷新数据 */
	onRefreshBtnClick: () => {
		if (state.planId) load.getWorkListData(unref(state.planId));	
	},


};

/* 公开的方法 */
const methods = {
	showDrawer: (ctId: string) => {
		load.getWorkListData(ctId);

		state.planId = ctId;
		// state.createUserId = insEmpNo;
		state.show = true;
	},

};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).show) = $event)),
    title: "流程轨迹"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: actions.onRefreshBtnClick
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(state).firstTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).firstTab) = $event)),
        type: "card",
        style: {"margin-top":"10px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tabList, (bill_no) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: bill_no,
              label: bill_no,
              name: bill_no
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                  ((_unref(state).workList || []).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_timeline, {
                        key: 0,
                        style: {"min-height":"150px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).workList, (item) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (item.bill_no == bill_no)
                                ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                                    key: 0,
                                    timestamp: item.node_name,
                                    placement: "top",
                                    hollow: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h4", {
                                        class: _normalizeClass(item.work_status_desc == '待处理' ? 'waittodo' : 'finish')
                                      }, "处理人：" + _toDisplayString(item.emp_name) + "(" + _toDisplayString(item.emp_no) + ")，动作：" + _toDisplayString(item.work_status_desc), 3),
                                      _createElementVNode("p", null, "操作时间：" + _toDisplayString(item.action_date_format ? item.action_date_format : '--'), 1),
                                      _createElementVNode("p", null, "审批意见：" + _toDisplayString(item.remark || '--'), 1),
                                      (item.urge_total > 0 && item.work_status == '0')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                            _hoisted_4,
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(item.urge_total) + "次", 1),
                                            _hoisted_6,
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(moment)(item.urge_time).format('YYYY-MM-DD HH:mm')), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.work_status == '0' && item.emp_no != _unref(login).user_account)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createVNode(_component_el_button, {
                                              type: "primary",
                                              size: "small",
                                              loading: _unref(state).urgeLoad,
                                              onClick: ($event: any) => (actions.onUrgeBtnClick(item.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_9
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["timestamp"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _unref(state).loading]
                ])
              ]),
              _: 2
            }, 1032, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (!(_unref(state).tabList.length))
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            size: "small",
            description: "暂无审批记录"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})